import useBootstrapData from './useBootstrapData';

export default function usePrivacyStatementUrl() {
  const bootstrapData = useBootstrapData();
  return (
    bootstrapData?.privacy_statement_url ??
    'https://help.sap.com/docs/build-service/build-service-guide/data-privacy-statement'
  );
}
